// The quick date-range chips shown on the analytics pages: Today,
// Last 7 days, the current year, and one chip per month of the current
// year. All of these are pre-warmed server-side (analytics:warm), so
// every chip is instant.
const iso = date => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

export function buildRangePresets(now = new Date()) {
  const year = now.getFullYear();
  const today = iso(now);
  const weekAgo = new Date(now);
  weekAgo.setDate(weekAgo.getDate() - 7);

  const presets = [
    { label: 'Today', start: today, end: today },
    { label: 'Last 7 days', start: iso(weekAgo), end: today },
    { label: `${year}`, start: `${year}-01-01`, end: today },
  ];

  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  for (let m = 0; m <= now.getMonth(); m++) {
    const monthEnd = new Date(year, m + 1, 0);
    presets.push({
      label: monthNames[m],
      start: iso(new Date(year, m, 1)),
      end: iso(monthEnd > now ? now : monthEnd),
    });
  }

  return presets;
}
